<template>
  <div class="dashboardFilterOuterWrapper">
    <div class="dashboardFilterWrapper" v-click-outside="_toggleControlMode">
      <div v-if="!(isControlModeActive || isHovered)" class="summaryMode" @click="_toggleControlMode(true)">
        <div v-if="!_isValid()" class="noFilterSelected">Select Filters</div>
        <div v-if="_isValid()" class="filtersDisplay">
          <div class="filterRow">
            <div class="filterTitle">Type:</div>
            <div class="filterValue">{{ _getSelectedTypeLabel() }}</div>
          </div>
          <div v-if="selectedType !== 2" class="filterRow">
            <div class="filterTitle">Facility:</div>
            <div class="filterValue">{{ this.selectedFacility && this.selectedFacility.name }}</div>
          </div>
          <div v-if="selectedType !== 2" class="filterRow">
            <div class="filterTitle">Date Range:</div>
            <div class="filterValue">
              {{ moment(dateRange.startDate).format("MM-DD-YYYY") | date }}
              -
              {{ moment(dateRange.endDate).format("MM-DD-YYYY") | date }}
            </div>
          </div>
          <div v-if="selectedType !== 1" class="filterRow">
            <div class="filterTitle">Due Range:</div>
            <div class="filterValue">{{ `${value[0]}-${value[1]}` }}</div>
          </div>
        </div>
        <div class="clearButton" @click="_clear">Clear</div>
      </div>
      <div v-if="isControlModeActive || isHovered" class="controlMode" @mouseenter="_toggleControlHover(true)"
        @mouseleave="_toggleControlHover(false)">
        <div class="controlWrapper">
          <div class="controlLabel">Select Type</div>
          <div class="control">
            <!-- <v-select
              v-model="selectedType"
              :items="allTypes"
              label="Select Type"
              item-text="label"
              item-value="value"
            /> -->
            <div class="select-dropdown">
              <select v-model="selectedType">
                <option :value="null">
                  Not selected
                </option>
                <option v-for="(item, i) in allTypes" :key="i" :value="item.value">
                  {{ item.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div v-if="selectedType !== 2 && selectedType !== null" class="controlWrapper">
          <div class="controlLabel">Select Facility</div>
          <div class="control">
            <!-- <v-select
              v-model="selectedType"
              :items="allTypes"
              label="Select Type"
              item-text="label"
              item-value="value"
            /> -->
            <div class="select-dropdown">
              <select v-model="selectedFacility">
                <option :value="null">
                  Not selected
                </option>
                <option v-for="(item, i) in allFacilities" :key="i" :value="item">
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div v-if="selectedType !== 1 && selectedType !== null" class="controlWrapper">
          <div class="controlLabel">Select Range</div>
          <div class="control">
            <template>
              <v-range-slider v-model="value" step="30" max="120" min="30" :tick-labels="dueDatesOptions" ticks="always"
                tick-size="4" @change="_updateRangeValue"></v-range-slider>
            </template>
          </div>
        </div>
        <div v-if="selectedType !== 2 && selectedType !== null" class="controlWrapper">
          <div class="controlLabel">Select Date Range</div>
          <div class="control">
            <template>
              <div class="dateRangePickerWrapper">
                <date-range-picker
                  ref="picker"
                  v-model="dateRange"
                  opens="left"
                  :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
                  :show-dropdowns="true"
                  :auto-apply="true"
                  @update="_updateValues"
                  @toggle="checkOpen"
                >
                  <template v-slot:input="picker">
                    <div class="datePicker">
                      <span v-if="picker.startDate && picker.endDate">
                        {{ moment(picker.startDate).format("MM-DD-YYYY") | date }}
                        -
                        {{ moment(picker.endDate).format("MM-DD-YYYY") | date }}
                      </span>
                      <span v-if="!(picker.startDate && picker.endDate)">
                        Select a date to load data
                      </span>
                      <v-icon>mdi-calendar</v-icon>
                    </div>
                  </template>
                </date-range-picker>
              </div>
            </template>
          </div>
        </div>
        <div class="bottomActionBar">
          <button class="save" :disabled="!_isValid()" @click="_submit">Save filters</button>
          <button class="dismiss" @click="_dismiss">Dismiss</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
import ClickOutside from "vue-click-outside";
import DateRangePicker from "vue2-daterange-picker";
import moment from "moment";
import { ApiCalls } from "../../../../api-calls";
import Api from "../../../shared-module/api";

// import HttpConnector from '../../../utils/http-connector'
// import AuthService from '@/services/AuthService'
// const auth = new AuthService()

export default {
  name: "DashboardFilter",
  components: {
    DateRangePicker
  },
  props: {
    //   labelText: {
    //     type: String,
    //     default: 'Help and support'
    //   }
  },
  data: () => ({
    isHovered: false,
    isControlModeActive: false,
    value: [30, 60],
    dueDatesOptions: [30, 60, 90, 120],
    selectedType: null,
    selectedFacility: null,
    allFacilities: [],
    allTypes: [
      {
        label: "Appointments",
        value: 1
      },
      {
        label: "Past Due Range",
        value: 2
      }
    ],
    dateRange: {},
    moment,
  }),

  watch: {
    //   dialog (val) {
    //     // eslint-disable-next-line no-unused-expressions
    //     if (!val) {
    //       this.close()
    //       this.reset()
    //     }
    //   },
    '$store.state.posActivePractice': function () {
      this._initialize();
      this._clear();
    },
    dateRange(val) {
      console.log("val", val);
    }
  },

  async created() {
    this._initialize();
  },

  methods: {
    checkOpen() {
      return false;
    },
    async _initialize() {
      try {
        if (this.$store.state.posActivePractice.value) {
          const { data } = await Api.practice.private.fetchAllFacilitiesByPracticeId(this.$store.state.posActivePractice.value);
          this.allFacilities = data;
        }
      } catch (error) {
        console.log("error", error);
      }
    },
    _toggleControlMode(isControlModeActive = false) {
      if (typeof isControlModeActive !== "boolean" && !this.isHovered) {
        this.isControlModeActive = false;
      } else if (isControlModeActive) {
        setTimeout(() => {
          this.isControlModeActive = true;
        }, 50);
      } else {
        this.isControlModeActive = isControlModeActive;
      }
    },
    _toggleControlHover(isHovered) {
      if (isHovered) {
        this.isHovered = true;
      } else {
        setTimeout(() => {
          this.isHovered = false;
        }, 100);
      }
    },
    _updateRangeValue(values) {
      console.log("values", values);
    },
    _updateValues() {
      if (this.dateRange.startDate && this.dateRange.endDate) {
        // Fetch data for the new date range
        this._initialize();
      }
    },
    _getSelectedTypeLabel() {
      const selectedOption = this.allTypes.find(t => t.value === this.selectedType);
      if (selectedOption) {
        return selectedOption.label;
      }
      return "";
    },
    _isValid() {
      let isDateRangeValid = false;
      const isRangeValid = true;
      let isFacilityValid = false;
      if (this.dateRange && this.dateRange.startDate && this.dateRange.endDate) {
        isDateRangeValid = true;
      }
      if (this.selectedFacility) {
        isFacilityValid = true;
      }
      if (this.selectedType === 0) {
        return isDateRangeValid && isRangeValid && isFacilityValid;
      } else if (this.selectedType === 1) {
        return isDateRangeValid && isFacilityValid;
      } else if (this.selectedType === 2) {
        return isRangeValid;
      }
    },
    _submit() {

      console.log('Selected Type: ' + this.selectedType);

      if (this.selectedType === 2) {
        const payload = {
          type: this.selectedType,
          startDate: moment(new Date("1/1/1753 12:00:00")).format("MM/DD/YYYY"),
          endDate: moment(new Date("12/31/9999 11:59:59")).format("MM/DD/YYYY"),
          startRange: this.value[0],
          endRange: this.value[1],
          PracticeID: this.$store.state.posActivePractice ? this.$store.state.posActivePractice.value : null
        };

        this.$emit("on-submit", payload);
        this._dismiss();
      } else {
        const payload = {
          type: this.selectedType,
          startDate: moment(this.dateRange.startDate).format("MM/DD/YYYY"),
          endDate: moment(this.dateRange.endDate).format("MM/DD/YYYY"),
          startRange: this.value[0],
          endRange: this.value[1],
          facilityID: this.selectedFacility.id ? this.selectedFacility.id : null,
          PracticeID: this.$store.state.posActivePractice ? this.$store.state.posActivePractice.value : null
        };

        this.$emit("on-submit", payload);
        this._dismiss();
      }
      
    },
    _dismiss() {
      this.isControlModeActive = false;
      this.isHovered = false;
    },
    _clear(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      this.isControlModeActive = false;
      this.value = [30, 60];
      this.dueDatesOptions = [30, 60, 90, 120];
      this.selectedType = 0;
      this.selectedFacility = null;
      this.dateRange = {};
      this.$emit("on-clear");
    }
  },
  directives: {
    ClickOutside
  }
};
</script>

<style lang="scss" scoped>
  .dashboardFilterOuterWrapper {
    width: 100px;
    height: 100px;
    z-index: 100;
    position: relative;

    * {
      transition: 0.3s !important;
    }

    transition: 0.3s !important;

    .dashboardFilterWrapper {
      min-width: 100px;
      margin-right: 10px;
      position: absolute;
      top: 0;
      right: 0;

      .summaryMode {
        min-width: 200px;
        padding-right: 20px;
        cursor: pointer;
        min-height: 40px;
        background-color: white;
        border: 2px solid rgb(114, 153, 114);
        border-radius: 5px;
        box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
        padding: 0px 7px;
        position: relative;

        .clearButton {
          position: absolute;
          top: 8px;
          right: 8px;
          font-size: 10px;
          font-weight: 600;
          padding: 2px 8px;
          color: white;
          border-radius: 15px;
          cursor: pointer;
          background-color: rgba(128, 128, 128, 0.404);

          &:hover {
            background-color: grey;
          }
        }

        .noFilterSelected {
          padding: 8px 15px;
        }

        &:hover {
          background-color: rgb(231, 231, 231);
        }

        .filtersDisplay {
          padding: 30px 8px 8px 8px;

          .filterRow {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .filterTitle {
              white-space: nowrap;
              font-weight: 600;
              padding-right: 3px;
            }

            .filterValue {
              white-space: nowrap;
            }
          }
        }
      }

      .controlMode {
        min-width: 600px;
        padding-right: 20px;
        cursor: pointer;
        min-height: 150px;
        background-color: white;
        border: 2px solid rgb(114, 153, 114);
        border-radius: 5px;
        box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
        padding: 0px 7px;
        .controlWrapper {
          margin-top: 15px;

          .controlLabel {
            font-weight: 600;
            padding: 5px 15px;
          }

          .control {
            padding: 5px 35px;
          }
        }
      }
    }

    .select-dropdown,
    .select-dropdown * {
      margin: 0;
      padding: 0;
      position: relative;
      box-sizing: border-box;
    }

    .select-dropdown {
      position: relative;
      background-color: #e6e6e6;
      border-radius: 4px;
    }

    .select-dropdown select {
      font-size: 1rem;
      font-weight: normal;
      width: 100%;
      padding: 8px 24px 8px 10px;
      border: none;
      background-color: transparent;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }

    .select-dropdown select:active,
    .select-dropdown select:focus {
      outline: none;
      box-shadow: none;
    }

    .select-dropdown:after {
      content: "";
      position: absolute;
      top: 50%;
      right: 8px;
      width: 0;
      height: 0;
      margin-top: -2px;
      border-top: 5px solid #aaa;
      border-right: 5px solid transparent;
      border-left: 5px solid transparent;
    }

    .bottomActionBar {
      width: 100%;
      padding: 15px 15px;
      display: flex;
      justify-content: flex-end;
      align-content: center;

      button {
        margin-left: 15px;
        padding: 5px 20px;
        font-size: 0.8rem;
        background-color: rgb(122, 121, 121);
        border-radius: 5px;
        color: white;

        &.save {
          background-color: green;
        }

        &:disabled {
          background-color: rgba(107, 107, 107, 0.219);
          pointer-events: none;
          cursor: not-allowed;
        }
      }
    }
  }
</style>
